/* 默认环境模式是开发模式 */
// 跳过下一行检查
// eslint-disable-next-line
const env = process.env.NODE_ENV
let mode = ''
if (env === 'development') {
  /* 本地环境 */
  mode = 'dev'
} else if (env === 'pre') {
  /* 打包开发环境 */
  mode = 'pre'
} else if (env === 'test') {
  /* 测试环境 */
  mode = 'test'
} else if (env === 'production') {
  /* 生产环境 */
  mode = 'prod'
}

/* 默认使用协议 */
const protocol = 'http'
const baseConfig = {
  protocols: {
    http: 'http://',
    https: 'https://'
  },
  /* 开发环境  39.170.19.183:23185*/
  dev: {
    base: '192.168.1.32:58003/lucas_face/',
    view: '192.168.1.32:9090/',
    face: '192.168.1.32:58003/lucas_face/',
    device: '192.168.1.32:58001/lucas_device/',
    region: '192.168.1.32:58001/lucas_device/',
    attendance: '192.168.1.32:58003/lucas_face/',
    video:'192.168.1.32:8080',
    videoShow:'192.168.1.32:8000/'
  },
  /* 测试环境 */
  test: {
    base: '192.168.31.69:58003/lucas_face/',
    view: '192.168.31.69:9090/',
    face: '192.168.31.69:58003/lucas_face/',
    device: '192.168.31.69:58001/lucas_device/',
    region: '192.168.31.69:58001/lucas_device/',
    attendance: '192.168.31.69:58003/lucas_face/'
  },
  /* 预生产环境 */
  pre: {
    base: '222.95.131.225:58003/lucas_face/',
    view: '222.95.131.225:9090/',
    face: '222.95.131.225:58003/lucas_face/',
    device: '222.95.131.225:58001/lucas_device/',
    region: '222.95.131.225:58001/lucas_device/',
    attendance: '222.95.131.225:58003/lucas_face/'
  },
  /* 生产环境
    121.37.191.177 华为云
    211.87.155.84 青岛
    192.168.31.69 正元
    192.168.10.109山西建筑学院
    192.168.106.217水利学院
    210.44.144.146 齐鲁工大
    192.168.3.90
    10.112.17.3 西南财经
    10.0.99.86 西宁世纪
    202.201.112.100 北方民族
    121.37.160.175 新华为云
    192.168.11.149 青海卫生
    192.168.1.66 公司测试地址
    10.2.7.51 山西工商
    172.19.99.11 兵团警官学院
    192.168.40.76 兵团警官学院
    192.168.48.209 湖州职业技术学院
    192.168.3.40 王林测试环境
   */
  prod: {
    base: '121.37.160.175:58003/lucas_face/',
    view: '121.37.160.175:9090/',
    face: '121.37.160.175:58003/lucas_face/',
    device: '121.37.160.175:58001/lucas_device/',
    region: '121.37.160.175:58001/lucas_device/',
    attendance: '121.37.160.175:58003/lucas_face/',
    video:'121.37.160.175:8081',
    videoShow:'121.37.160.175:8000/'
  }
}
/* 设置api转换 */
let apiFormat = (api = '', hostkey = 'base', pt = protocol) =>
  baseConfig.protocols[pt] + baseConfig[mode][hostkey] + api

let apiFace = (api = '', hostkey = 'face', pt = protocol) =>
  baseConfig.protocols[pt] + baseConfig[mode][hostkey] + api

let apiDevice = (api = '', hostkey = 'device', pt = protocol) =>
  baseConfig.protocols[pt] + baseConfig[mode][hostkey] + api

let apiRegion = (api = '', hostkey = 'region', pt = protocol) =>
  baseConfig.protocols[pt] + baseConfig[mode][hostkey] + api

let apiView = (api = '', hostkey = 'view', pt = protocol) =>
  baseConfig.protocols[pt] + baseConfig[mode][hostkey] + api

let apiAttendance = (api = '', hostkey = 'attendance', pt = protocol) =>
  baseConfig.protocols[pt] + baseConfig[mode][hostkey] + api

const api = {
  base: {
    login: apiFormat('userApi/login'),
    loginOut: apiFormat('userApi/logout')
  },
  /* 定义功能名称或者api分组名称 */
  apiList: {
    /* 角色 */
    queryMenuByRoleId: apiFormat('roleApi/queryMenuByRoleId'),
    queryRoleByPage: apiFormat('roleApi/queryRoleByPage'),
    queryAllRole: apiFormat('roleApi/queryAllRole'),
    getRoleDetail: apiFormat('roleApi/getRoleDetail'),
    addRole: apiFormat('roleApi/addRole'),
    updateRole: apiFormat('roleApi/updateRole'),
    delRole: apiFormat('roleApi/delRole'),
    queryRoleResConfig: apiFormat('roleApi/queryRoleResConfig'),
    saveRoleResConfig: apiFormat('roleApi/saveRoleResConfig'),
    /* 用户 api */
    queryUserByPage: apiFormat('userApi/queryUserByPage'),
    queryAllUser: apiFormat('userApi/queryAllUser'),
    getUserDetail: apiFormat('userApi/getUserDetail'),
    addUser: apiFormat('userApi/addUser'),
    updateUser: apiFormat('userApi/updateUser'),
    delUser: apiFormat('userApi/delUser'),
    bandAppKey: apiFormat('userApi/bindAppKey'),
    /** 菜单api */
    queryResourceByPage: apiFormat('resourceApi/queryResourceByPage'),
    queryAllResource: apiFormat('resourceApi/queryAllResource'),
    getResourceDetail: apiFormat('resourceApi/getResourceDetail'),
    addResource: apiFormat('resourceApi/addResource'),
    updateResource: apiFormat('resourceApi/updateResource'),
    delResource: apiFormat('resourceApi/delResource')

  },
  /* 应用相关接口 */
  app: {
    queryAppInfoList: apiFace('appInfoApi/queryAppInfoByPage'),
    queryAllAppInfo: apiFace('appInfoApi/queryAllAppInfo'),
    createApp: apiFace('appInfoApi/addAppInfo'),
    editApp: apiFace('appInfoApi/updateAppInfo'),
    delApp: apiFace('appInfoApi/delAppInfo')
  },
  /* 考勤相关接口 */
  attendance: {
    queryAttendanceGroupPage: apiAttendance('attendanceGroupApi/queryAttendanceGroupPage'),
    queryAllAttendanceGroup: apiAttendance('attendanceGroupApi/queryAllAttendanceGroup'),
    addAttendanceGroup: apiAttendance('attendanceGroupApi/addAttendanceGroup'),
    updateAttendanceGroup: apiAttendance('attendanceGroupApi/updateAttendanceGroup'),
    queryBandFaceByGroupCode: apiAttendance('attendanceGroupApi/queryBandFaceByGroupCode'),
    delAttendanceGroup: apiAttendance('attendanceGroupApi/delAttendanceGroup'),
    /* 考勤规则 */
    queryAttendanceRuleByPage: apiAttendance('attendanceRuleApi/queryAttendanceRuleByPage'),
    queryAllAttendanceRule: apiAttendance('attendanceRuleApi/queryAllAttendanceRule'),
    addAttendanceRule: apiAttendance('attendanceRuleApi/addAttendanceRule'),
    updateAttendanceRule: apiAttendance('attendanceRuleApi/updateAttendanceRule'),
    delAttendanceRule: apiAttendance('attendanceRuleApi/delAttendanceRule'),
    /* 考勤记录 */
    queryAttendanceRecordByPage: apiAttendance('attendanceRecordApi/queryAttendanceRecordByPage')
  },
  view: {
    viewUrl: apiView('#/regionId=')
  },
  /* 位置相关接口 */
  region: {
    queryRegionTree: apiRegion('regionInfoApi/queryRegionTree'),
    addRegionInfo: apiRegion('regionInfoApi/addRegionInfo'),
    delRegionInfo: apiRegion('regionInfoApi/delRegionInfo'),
    updateRegionInfo: apiRegion('regionInfoApi/updRegionInfo'),
    getRegionInfoDetail: apiRegion('regionInfoApi/getRegionInfoDetail')
  },
  device: {
    /* 设备域api */
    queryDeviceInfoByPage: apiDevice('deviceInfoApi/queryDeviceTreeWithSubByPage'),
    queryDeviceTreeWithSub: apiDevice('deviceInfoApi/queryDeviceTreeWithSub'),
    getDeviceInfoDetail: apiDevice('deviceInfoApi/getDeviceInfoDetail'),
    addDeviceInfo: apiDevice('deviceInfoApi/addDeviceInfo'),
    updDeviceInfo: apiDevice('deviceInfoApi/updDeviceInfo'),
    delDeviceInfo: apiDevice('deviceInfoApi/delDeviceInfo'),
    addDeviceCommand: apiDevice('deviceInfoApi/addDeviceCommand'),
    queryDeviceStatusLogByPage: apiDevice('deviceInfoApi/queryDeviceStatusLogByPage'),
    upgrade: apiDevice('deviceInfoApi/upgrade'),
    powerManage: apiDevice('deviceInfoApi/powerManage'),
    /** 关联关系 */
    batchAddBizRef: apiDevice('bizRefApi/batchAddByDeviceCodes'),
    queryDeviceCodeSet: apiDevice('bizRefApi/queryDeviceCodeSet'),
    queryBizIdSet: apiDevice('bizRefApi/queryBizIdSet'),
    addBizRef: apiDevice('bizRefApi/addBizRef'),
    batchAddByBizIds: apiDevice('bizRefApi/batchAddByBizIds'),
    batchAddByBizIdsAndModules: apiDevice('bizRefApi/batchAddByBizIdsAndModules'),
    /* 设备类型 */
    queryDeviceTypeByPage: apiDevice('deviceTypeApi/queryDeviceTypeByPage'),
    queryDeviceType: apiDevice('deviceTypeApi/queryAllDeviceType'),
    getDeviceTypeDetail: apiDevice('deviceTypeApi/getDeviceTypeDetail'),
    addDeviceType: apiDevice('deviceTypeApi/addDeviceType'),
    updDeviceType: apiDevice('deviceTypeApi/updDeviceType'),
    delDeviceType: apiDevice('deviceTypeApi/delDeviceType'),
    /** 设备状态 */
    queryDeviceStateByTypeId: apiDevice('deviceStateApi/queryDeviceStateByTypeId'),
    addDeviceState: apiDevice('deviceStateApi/addDeviceState'),
    updDeviceState: apiDevice('deviceStateApi/updDeviceState'),
    delDeviceState: apiDevice('deviceStateApi/delDeviceState'),
    /** 设备属性 */
    queryDeviceAttrList: apiDevice('deviceAttrApi/queryDeviceAttrList'),
    queryDeviceAttrAndValList: apiDevice('deviceAttrApi/queryDeviceAttrAndValList'),
    addDeviceAttr: apiDevice('deviceAttrApi/addDeviceAttr'),
    updDeviceAttr: apiDevice('deviceAttrApi/updDeviceAttr'),
    delDeviceAttr: apiDevice('deviceAttrApi/delDeviceAttr'),
    addDeviceAttrVal: apiDevice('deviceAttrApi/addDeviceAttrVal'),
    updDeviceAttrVal: apiDevice('deviceAttrApi/updDeviceAttrVal'),
    addOrUpdDeviceAttrVal: apiDevice('deviceAttrApi/addOrUpdDeviceAttrVal'),
    delDeviceAttrVal: apiDevice('deviceAttrApi/delDeviceAttrVal'),
    /* 设备版本升级 */
    upgradeVersionDeviceList: apiDevice('deviceVersionApi/queryDeviceVersionTreeWithSubByPage'),
    addDeviceVersionAttr: apiDevice('deviceVersionApi/addDeviceVersion'),
    updateDeviceVersionAttr: apiDevice('deviceVersionApi/updateDeviceVersion'),
    delDeviceVersionAttr: apiDevice('deviceVersionApi/DelDeviceVersion'),

    /* 设备广告推送管理 */
    newsInfoList: apiDevice('newsInfoApi/queryNewsTreeWithSubByPage'),
    addNewsInfo: apiDevice('newsInfoApi/addNewsInfo'),
    newsInfoDetail: apiDevice('newsInfoApi/getNewsInfoDetail'),
    newsInfoRef: apiDevice('newsInfoRefApi/addNewsInfoRef'),
    newsInfoRefList: apiDevice('newsInfoRefApi/queryNewsInfoRefList'),

    /* 大屏页面获取相机ip接口 */
    queryDeviceSet: apiDevice('bizRefApi/queryDeviceSet'),
    websocketFace: "ws://"+baseConfig[mode]["base"]+"/websocket/",
    websocketVideo: "ws://"+baseConfig[mode]["video"],

    /** 系统配置api */
    querySysConf: apiDevice('sysConfApi/querySysConfByPage'),
    selectSysConf: apiDevice('sysConfApi/selectSysConf'),
    addSysConf: apiDevice('sysConfApi/addSysConf'),
    updateSysConf: apiDevice('sysConfApi/updateSysConf'),
    delSysConf: apiDevice('sysConfApi/delSysConf'),

    /** 推送配置api */
    queryOutSysConfByPage: apiDevice('outSysConfApi/queryOutSysConfByPage'),
    addOutSysConf: apiDevice('outSysConfApi/addOutSysConf'),
    updateOutSysConf: apiDevice('outSysConfApi/updateOutSysConf'),
    delOutSysConf: apiDevice('outSysConfApi/delOutSysConf')
  },
  /* 脸库相关接口 */
  face: {
    /* 脸库相关接口 */
    queryFaceSetByPage: apiFace('faceSetApi/queryFaceSetByPage'),
    queryAllFaceSet: apiFace('faceSetApi/queryAllFaceSet'),
    queryFaceSetDetail: apiFace('faceSetApi/queryFaceSetDetail'),
    addFaceSet: apiFace('faceSetApi/addFaceSet'),
    updateFaceSet: apiFace('faceSetApi/updateFaceSet'),
    delFaceSet: apiFace('faceSetApi/delFaceSet'),
    /* 人脸相关接口 */
    queryFaceInfoDetail: apiFace('faceInfoApi/queryFaceInfoDetail'),
    addFaceInfo: apiFace('faceInfoApi/addFaceInfo'),
    addBlankFace: apiFace('faceInfoApi/addBlankFace'),
    updateFaceInfo: apiFace('faceInfoApi/updateFaceInfo'),
    queryFaceInfoByPage: apiFace('faceInfoApi/queryFaceInfoByPage'),
    queryAllFaceInfo: apiFace('faceInfoApi/queryAllFaceInfo'),
    queryFaceRecordByPage: apiFace('faceRecordApi/queryFaceRecordByPage'),
    queryUnidentFaceRecordByPage: apiFace('unidentFaceRecordApi/queryUnidentFaceRecordByPage'),
    delFaceInfo: apiFace('faceInfoApi/delFaceInfo'),
    editFaceBlack: apiFace('faceInfoApi/editFaceBlack'),
    editFaceWhite: apiFace('faceInfoApi/editFaceWhite'),
    syncFaceInfoCloud: apiFace('faceInfoApi/syncFaceInfoCloud'),
    faceSetBandDevice: apiFace('faceSetBandApi/faceSetBandDevice'),
    batchSaveFaceInfo: apiFace('faceInfoApi/batchSaveFaceInfo'),
    /* 人员类型接口 */
    queryAllPersonType: apiFace('personTypeApi/queryAllPersonType'),
    addPersonType: apiFace('personTypeApi/addPersonType'),
    updatePersonType: apiFace('personTypeApi/updatePersonType'),
    queryPersonTypeByPage: apiFace('personTypeApi/queryPersonTypeByPage'),
    /* 文件上传接口 */
    uploadFace: apiFace('fileUpload/upload'),
    uploadFile: apiFace('fileUpload/file'),
    delFile: apiFace('fileUpload/delete'),   //删除文件
    batchUploadFace: apiFace('fileUpload/batchUploadFile'),
    /** 人脸定时任务接口 */
    addFaceTask: apiFace('faceTaskApi/addFaceTask'),
    queryFaceTaskByPage: apiFace('faceTaskApi/queryFaceTaskByPage'),
    queryFaceTaskErrorByPage: apiFace('faceTaskApi/queryFaceTaskErrorByPage'),
    /* 识别相关接口 */
    faceDetect: apiFace('face/detect'),
    faceSearchOne: apiFace('face/searchOne'),
    lessSearch: apiFace('face/lessSearch'),
    faceSearch: apiFace('face/search'),

    /*算法开关*/
    faceServiceSwitchList: apiFace('switchApi/querySwitchByPage'),
    addFaceServiceSwitch: apiFace('switchApi/addSwitch'),
    updateFaceServiceSwitch: apiFace('switchApi/updateSwitch'),
    delFaceServiceSwitch: apiFace('switchApi/delSwitch'),

    /*进出记录*/
    localFaceCardRecordList: apiFace('localFaceCardRecordApi/queryLocalFaceCardRecordByPage'),

    //获取视频地址
    netDvrGetFileByTime:apiFace('nvr/netDvrGetFileByTime'),
    netDvrGetFileByTimeWithPad:apiFace('nvr/netDvrGetFileByTimeWithPad'),
    VideoIp: "http://"+baseConfig[mode]["videoShow"]
  }
}

export default api



// WEBPACK FOOTER //
// ./src/config/apiConfig.js